var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "border-bottom insety-16" },
    [
      _c(
        "ib-row",
        [
          _c("ib-col", { staticClass: "xl2 s12" }, [
            _c(
              "p",
              {
                staticClass: "insety-16",
                class: {
                  "insetx-4": !_vm.$media.m,
                  "insetx-8": _vm.$media.l,
                  "insetx-16": _vm.$media.xl,
                },
              },
              [
                _c(
                  "span",
                  {
                    staticClass: "insetx-8 info",
                    class: { "start-0": !_vm.$media.m },
                  },
                  [
                    _c("svg", { attrs: { viewBox: "0 0 13 13" } }, [
                      _c("path", {
                        attrs: {
                          d: "M6.5 0A6.5 6.5 0 1013 6.5 6.5 6.5 0 006.5 0z",
                        },
                      }),
                      _c("path", {
                        attrs: {
                          d: "M6.5 2.543a.848.848 0 10.848.848.848.848 0 00-.848-.848zM5.37 5.37v.565h.565v3.674H5.37v.565h2.26v-.565h-.565V5.37z",
                          fill: "#fff",
                        },
                      }),
                    ]),
                    _c("span", { staticClass: "tooltext" }, [
                      _vm._v(_vm._s(_vm.$t("companies_by_group"))),
                    ]),
                  ]
                ),
                _c("span", [_vm._v(_vm._s(_vm.$t("companies_by_group")))]),
                _c("br"),
                _c(
                  "span",
                  {
                    staticClass: "fs7 fg50",
                    class: { "insetx-8": _vm.$media.m },
                  },
                  [_vm._v("(" + _vm._s(_vm.$t("maximum_25")) + ")")]
                ),
              ]
            ),
          ]),
          _c(
            "ib-col",
            {
              staticClass: "xl10",
              class: {
                "inset-16": _vm.$media.xl,
                "insety-16": _vm.$media.s,
                "insetx-16": _vm.$media.xl,
              },
            },
            [
              _vm.groups.length === 0
                ? _c(
                    "ib-button",
                    {
                      staticClass: "add-edit comp-but",
                      class: { "text-left": _vm.$media.s },
                      attrs: { tone: "accent" },
                      on: {
                        click: function ($event) {
                          return _vm.editGroup()
                        },
                      },
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("add")) +
                          "/" +
                          _vm._s(_vm.$t("edit_companies"))
                      ),
                    ]
                  )
                : _c(
                    "ul",
                    { staticClass: "start-16" },
                    _vm._l(_vm.groups, function (group, index) {
                      return _c(
                        "li",
                        { key: index },
                        [
                          _c("p", { staticClass: "before-16 border-bottom" }, [
                            _vm._v("Group " + _vm._s(index + 1)),
                          ]),
                          _c(
                            "ib-table-basic",
                            {
                              staticClass: "group-table",
                              attrs: { data: group.companies },
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "body",
                                    fn: function (company) {
                                      return [
                                        _c(
                                          "td",
                                          [
                                            _c("ib-checkbox", {
                                              attrs: {
                                                value: company.selected,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleSelect(
                                                    index,
                                                    company.id
                                                  )
                                                },
                                              },
                                            }),
                                          ],
                                          1
                                        ),
                                        _c("td", [
                                          _vm._v(_vm._s(company.ticker)),
                                        ]),
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(_vm.formatComp(company.name))
                                          ),
                                        ]),
                                        company.type === "stocks"
                                          ? _c("td", [
                                              _c("span", [
                                                _vm._v(_vm._s(_vm.$t("stock"))),
                                              ]),
                                            ])
                                          : company.type === "etfs"
                                          ? _c("td", [
                                              _c("span", [
                                                _vm._v(_vm._s(_vm.$t("etf"))),
                                              ]),
                                            ])
                                          : _vm._e(),
                                      ]
                                    },
                                  },
                                ],
                                null,
                                true
                              ),
                            },
                            [
                              _c("ib-table-col", { attrs: { width: "5ch" } }),
                              _c("ib-table-col", { attrs: { width: "16ch" } }, [
                                _vm._v(_vm._s(_vm.$t("symbol"))),
                              ]),
                              _c("ib-table-col", [
                                _vm._v(_vm._s(_vm.$t("name"))),
                              ]),
                              _c("ib-table-col", [
                                _vm._v(_vm._s(_vm.$t("type"))),
                              ]),
                            ],
                            1
                          ),
                          _c(
                            "ib-button-group",
                            { staticClass: "before-8 after-8" },
                            [
                              _c(
                                "ib-button",
                                {
                                  staticClass: "add-edit",
                                  attrs: { tone: "accent" },
                                  on: {
                                    click: function ($event) {
                                      return _vm.editGroup(index)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    _vm._s(_vm.$t("add")) +
                                      "/" +
                                      _vm._s(_vm.$t("edit_companies"))
                                  ),
                                ]
                              ),
                              _c(
                                "ib-button",
                                {
                                  on: {
                                    click: function ($event) {
                                      return _vm.editGroup()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("add_group")))]
                              ),
                              _vm.groups.length > 1
                                ? _c(
                                    "ib-button",
                                    {
                                      on: {
                                        click: function ($event) {
                                          return _vm.removeGroup(index)
                                        },
                                      },
                                    },
                                    [_vm._v(_vm._s(_vm.$t("delete_group")))]
                                  )
                                : _vm._e(),
                            ],
                            1
                          ),
                        ],
                        1
                      )
                    }),
                    0
                  ),
            ],
            1
          ),
        ],
        1
      ),
      _c("EditCompanies", { ref: "editCompanies", on: { update: _vm.update } }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }